import { useForm } from "@inertiajs/react"
import type { ReactNode } from "react"
import { useState } from "react"

import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog"
import { Label } from "@/components/ui/label"
import { Textarea } from "@/components/ui/textarea"
import type RequestsCreateReport from "@/types/serializers/RequestsCreateReport"

const REASON_OPTIONS = [
  { value: "spam", label: "Spam" },
  { value: "acoso", label: "Acoso" },
  { value: "contenido_inapropiado", label: "Contenido inapropiado" },
  { value: "perfil_falso", label: "Perfil falso" },
  { value: "otro", label: "Otro" },
]

interface ReportDialogProps {
  reportableType: string
  reportableId: number
  children: ReactNode
}

export default function ReportDialog({
  reportableType,
  reportableId,
  children,
}: ReportDialogProps) {
  const [open, setOpen] = useState(false)
  const { data, setData, post, processing, reset } =
    useForm<RequestsCreateReport>({
      report: {
        reportable_type: reportableType,
        reportable_id: reportableId,
        reason: "",
        description: "",
      },
    })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    post("/reports", {
      onSuccess: () => {
        reset()
        setOpen(false)
      },
      preserveScroll: true,
    })
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Reportar contenido</DialogTitle>
          <DialogDescription>Indicá el motivo del reporte.</DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit}>
          <div className="space-y-4">
            <div>
              <Label>Motivo</Label>
              <select
                value={data.report.reason}
                onChange={(e) =>
                  setData("report", { ...data.report, reason: e.target.value })
                }
                className="border-border bg-card mt-1 w-full rounded-md border px-3 py-2 text-sm"
              >
                <option value="">Seleccionar motivo...</option>
                {REASON_OPTIONS.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <Textarea
                placeholder="Descripción opcional..."
                value={data.report.description}
                onChange={(e) =>
                  setData("report", {
                    ...data.report,
                    description: e.target.value,
                  })
                }
                rows={3}
              />
            </div>
          </div>
          <DialogFooter className="mt-4">
            <Button type="submit" disabled={processing || !data.report.reason}>
              Enviar reporte
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  )
}
